import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Feature extends BasicEntity {
chronoCode: string;
code: string;
description: TranslatedEmb;
dynamic: boolean | null;
kind: string;
label: TranslatedEmb;
perimeter: string;
visionCode: string;
}

